import {
  Box,
  Button,
  makeStyles,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import PropTypes from 'prop-types';
import { useState, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import CreateAgency from './CreateAgency';
import AgencyDetailModal from './AgencyDetailModal';
import { useTheme, useMediaQuery } from '@material-ui/core';
import SearchInput from '../../../components/input/SearchInput';
import { getListAgenciesByProvince } from 'src/features/agencySlice';
import AgencyAccountInfoDialog from './AgencyAccountInfoDialog';

const CssTextField = withStyles({
  root: {
    margin: 0
  }
})(TextField);

const Toolbar = ({ searchRef, listProvinces }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isAdmin, isSale, isAgency, isCustomerCare, isLeadMarketing } = useSelector(state => state.authSlice);
  const canManage = Boolean(isAdmin || isSale || isLeadMarketing || isAgency);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const listAgenciesByProvince = useSelector(
    state => state.agencySlice.listAgenciesByProvince
  );

  useEffect(() => {
    dispatch(
      getListAgenciesByProvince({
        page: 1,
        page_size: 1000
      })
    );
  }, [dispatch]);

  const deviceCountByProvince = useMemo(() => {
    return (listAgenciesByProvince || []).reduce((acc, agency) => {
      const provinceId = String(agency?.leader?.citizen_id || '');
      const devicesTotal = Number(agency?.devicesTotal) || 0;

      if (!provinceId) {
        return acc;
      }

      acc[provinceId] = (acc[provinceId] || 0) + devicesTotal;
      return acc;
    }, {});
  }, [listAgenciesByProvince]);

  const [query, setQuery] = useState({
    citizen_id: undefined,
    keywords: undefined,
    page: 1,
    page_size: isMobile ? 6 : PAGE_SIZE_LIST
  });

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);

  // Memoize handlers để tối ưu hiệu năng
  const handleSearchChange = useCallback(value => {
    setQuery(prevQuery => ({
      ...prevQuery,
      keywords: value || undefined,
      page: 1
    }));
  }, []);

  const handleSearch = useCallback(
    value => {
      setQuery(prevQuery => {
        const newQuery = {
          ...prevQuery,
          keywords: value || undefined,
          page: 1
        };
        if (searchRef) {
          searchRef(newQuery);
        }
        return newQuery;
      });
    },
    [searchRef]
  );

  const handleFilter = useCallback(
    e => {
      setQuery(prevQuery => {
        const newQuery = {
          ...prevQuery,
          citizen_id: e.target.value
        };
        if (searchRef) {
          searchRef(newQuery);
        }
        return newQuery;
      });
    },
    [searchRef]
  );

  const handleOpenCreateModal = useCallback(() => {
    setOpenCreateModal(true);
  }, []);

  const handleOpenDetailModal = useCallback(() => {
    dispatch(
      getListAgenciesByProvince({
        page: 1,
        page_size: 1000
      })
    );
    setOpenDetailModal(true);
  }, [dispatch]);

  const closeModal = useCallback(() => {
    setOpenCreateModal(false);
  }, []);

  const closeDetailModal = useCallback(() => {
    setOpenDetailModal(false);
  }, []);

  const handleAgencyCreated = useCallback(info => {
    setAccountInfo(info);
  }, []);

  const handleCloseAccountInfo = useCallback(() => {
    setAccountInfo(null);
  }, []);

  return (
    <div className={classes.root}>
      {openCreateModal && (
        <CreateAgency
          open={openCreateModal}
          onClose={closeModal}
          onCreated={handleAgencyCreated}
        />
      )}
      <AgencyAccountInfoDialog
        open={Boolean(accountInfo)}
        accountInfo={accountInfo}
        onClose={handleCloseAccountInfo}
      />
      {openDetailModal && (
        <AgencyDetailModal
          open={openDetailModal}
          onClose={closeDetailModal}
          listProvinces={listProvinces}
          listAgenciesByProvince={listAgenciesByProvince}
        />
      )}
      <Box>
        <Box className={classes.groupSearch}>
          <div className={classes.groupSearchLeft}>
            <Typography className={classes.title}>Quản trị đại lý</Typography>
          </div>
          <Box
            style={{
              marginLeft: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <SearchInput
              value={query.keywords || ''}
              onChange={handleSearchChange}
              onSearch={handleSearch}
              className={'searchInputDevice'}
              placeholder="Tên, số điện thoại hoặc email"
            />
            {!isCustomerCare && (
              <Box style={{ width: '172px' }}>
                <CssTextField
                  className="input-no-fieldset"
                  size="small"
                  fullWidth
                  select
                  margin="normal"
                  name="citizen_id"
                  onChange={handleFilter}
                  SelectProps={{
                    native: true
                  }}
                  InputProps={{
                    style: {
                      fontSize: '14px',
                      backgroundColor: '#ffffff',
                      padding: '1px 0px'
                    }
                  }}
                  //value={provinceSelected}
                  variant="outlined"
                >
                  <option value={''}>Tất cả tỉnh thành</option>
                  {listProvinces &&
                    listProvinces.length > 0 &&
                    listProvinces?.map((item, index) => {
                      const totalDevices =
                        deviceCountByProvince[String(item.id)] || 0;
                      return (
                        <option key={index} value={item.id}>
                          {`${item.name} (${totalDevices.toLocaleString('en-US')})`}
                        </option>
                      );
                    })}
                </CssTextField>
              </Box>
            )}
            {canManage && (
              <Button
                style={{
                  color: '#ffff'
                }}
                className={classes.styleInputSearch}
                color="secondary"
                variant="contained"
                onClick={handleOpenDetailModal}
              >
                {'Xem trên bản đồ'}
              </Button>
            )}
            {canManage && (
              <Button
                style={{
                  ...(isMobile && { lineHeight: '18px' }),
                  color: '#ffff'
                }}
                className={classes.styleInputSearch}
                color="secondary"
                variant="contained"
                onClick={handleOpenCreateModal}
              >
                {isMobile ? 'Thêm đại lý' : 'Thêm mới đại lý'}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#0C1132',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      fontWeight: '500'
    }
  },
  groupSearch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '50%',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      gap: '8px'
    }
  },
  groupSearchLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  searchInput: {
    width: '250px'
  },
  styleInputSearch: {
    height: '39px',
    textTransform: 'none',
    padding: '0px 1em'
  },
  exportBtn: {
    justifyContent: 'flex-end',
    display: 'flex',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  shadowBox: {
    boxShadow: '0 2px 5px rgba(0,0,0,.18)'
  }
}));

export default Toolbar;
